import React from 'react';
import { connect } from 'react-redux'
import moment from 'moment';
import numeral from 'numeral';

import NewChart from "./Charts";
import { calcQuarters } from '../../utilities/QuarterDates';

import "../../../styles/common.css";
import "../../../styles/common.charts.css";



const mapStateToProps = state => {
    return {
        lempgUserType: state.rootReducer.lempgUserType,
        user: state.rootReducer.user,
        selectedCounty: state.rootReducer.selectedCounty,
        selectedYear: state.rootReducer.selectedYear
    };
};


class AvailableGrantFundsDoughnutChart extends React.Component {

    state = {

    }


    checkQuarterBasedOnDate = (quarterStart, quarterEnd) => {
        var start = new Date(quarterStart);
        var current = new Date();
        var end = new Date(quarterEnd);
        return (start < current && current < end);
    }

    checkWhichQuarters = () => {
        let obj = calcQuarters(this.props.selectedYear);


        // Check per quarter basis, which quarter we are in

        if (this.checkQuarterBasedOnDate(obj.quarter1.start, obj.quarter1.end)) {
            return ["quarter1"];
        } else if (this.checkQuarterBasedOnDate(obj.quarter2.start, obj.quarter2.end)) {
            return ["quarter1", "quarter2"];
        } else if (this.checkQuarterBasedOnDate(obj.quarter3.start, obj.quarter3.end)) {
            return ["quarter1", "quarter2", "quarter3"];
        } else if (this.checkQuarterBasedOnDate(obj.quarter4.start, obj.quarter4.end)) {
            return ["quarter1", "quarter2", "quarter3", "quarter4"];
        }

        return [];
    }

    calculateAmount = (type, currentQuarter) => {
        let amount = 0;
        if (!currentQuarter[type]) return amount;
        if (!currentQuarter[type].items) return amount;
        if (!currentQuarter[type].items.length) return amount;

        currentQuarter[type].items.forEach((item) => {
            if (!item.deleted) {
                if (item.quarterAmount && !isNaN(parseFloat(item.quarterAmount))) {
                    amount += parseFloat(item.quarterAmount);
                }
                // if (item.matchAmount && !isNaN(parseFloat(item.matchAmount))) {
                //     amount += parseFloat(item.matchAmount);
                // }
                if (item.taxAmount && !isNaN(parseFloat(item.taxAmount))) {
                    amount += parseFloat(item.taxAmount);
                }
            }
        })

        return Number.parseFloat(amount).toFixed(2);
    }

    /**
     * 
     * Calculates amount for a financial reimbursements by amountType
     * 
     */

    getQuarterAmountByAmountType = (currentQuarter) => {
        let totalAmount = 0;

        let types = [
            "personnel",
            "equipment",
            "contractualService",
            "supply",
            "travel",
            "cert",
            "other"
        ]

        types.forEach((type) => {
            totalAmount += parseInt(this.calculateAmount(type, currentQuarter))
        })

        return parseInt(totalAmount);
    }

    getEstimatedCountyBudgetFromGrantApplication = (county) => {

        var arr = []

        /**
         * 
         * Line chart will be calculated by calculating percentage of individual category vs summation of entered amount in category
         * 
        */


        var applicationTypes = ['salary', 'contractualService', 'travel', 'equipment', 'supply', 'other', 'cert'];

        // First calculate total amount awarded for all types
        // Then calculate how much percent is being used in each category

        if (county.grantapplication && county.grantapplication.items) {
            county.grantapplication.items.forEach((grantApp) => {
                
                let amount = 0;
                let obj = {
                    'salary': 0,
                    'contractualService': 0,
                    'travel': 0,
                    'supply': 0,
                    'other': 0,
                    'cert': 0,
                    'equipment': 0,
                }

                applicationTypes.forEach((type) => {
                    grantApp[type].items.forEach((item) => {
                        if (!item.deleted) {

                            let typesOfFunding = ["federal"]
                            let sum = 0;

                            typesOfFunding.forEach((typeOfFunding) => {

                                if (item[typeOfFunding] && parseInt(item[typeOfFunding]) && !isNaN(parseInt(item[typeOfFunding]))) {
                                    sum += parseInt(item[typeOfFunding]);
                                }
                            })

                            // Individual category sum
                            obj[type] += sum;

                            // Total sum
                            amount += sum;
                        }
                    })

                })

                // Calculate average for all types

                Object.keys(obj).forEach((type) => {
                    // let a = isNaN((obj[type] / amount) * 100) ? 0 : ((obj[type] / amount) * 100)
                    arr.push(obj[type])
                });

            });
        }

        return arr
    }    

    constructor(props, context) {
        super(props, context);
    }

    calculateConfig = () => {
        
        /**
         * 
         * - Grab all federal amounts for sections defined in grant application
         * - Then calculate how much did we spent in a financial quarter
         * - Show the percentage in the chart
         * 
         */

        /**
         * To calculate `Total money spent by county` we have to calculate the total amount all county were awarded and then how much they have spent up until the current quarter
         */

        let data = [];
        let totalAwardAmountForAllCounty = 0;
        let totalSpentAmount = 0;
        let quarters = this.checkWhichQuarters();
        let sumGrantApplication = this.getEstimatedCountyBudgetFromGrantApplication(this.props.selectedCounty)

        // Calculate total award amounts for all county

        totalAwardAmountForAllCounty = sumGrantApplication.reduce((a, b) => a + b, 0)

        this.state.totalAwardAmountForAllCounty = totalAwardAmountForAllCounty;

        // Calculate amount spent by county
        let county = this.props.selectedCounty;

        if (county.financialreimbursement && county.financialreimbursement.items) {

            // Get financial reimbursements forms for quarters up until now
            let forms = []

            county.financialreimbursement.items.forEach((item) => {
                if (item.status == "PROCESSED") {
                    if (quarters.indexOf(item.quarter) >= 0) {
                        forms.push(item);
                    }
                }
            })

            forms.forEach((form) => {
                totalSpentAmount += this.getQuarterAmountByAmountType(form)
            })
        }

        let percentAmoutSpent = ((totalSpentAmount / totalAwardAmountForAllCounty) * 100);

        this.state.percentAmoutSpent = percentAmoutSpent;

        let config = {
            type: 'doughnut',
            data: {
                datasets: [{
                    data: [
                        percentAmoutSpent, (100 - percentAmoutSpent)
                    ],
                    backgroundColor: [
                        "#417505",
                        "#a1a1a1",
                    ],
                    label: 'TOTAL MONEY SPENT BY COUNTIES'
                }],
                labels: [
                    'Spent',
                    'Remaining',
                ]
            },
            options: {
                layout: {
                    padding: {
                        top: 16
                    },
                },
                cutoutPercentage: 70,
                responsive: true,
                segmentShowStroke: false,
                elements: {
                    arc: {
                        borderWidth: 0
                    }
                },
                legend: {
                    display: false,
                },
                tooltips: {
                    callbacks: {
                        label: (tooltipItem, data) => {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var meta = dataset._meta[Object.keys(dataset._meta)[0]];
                            var total = meta.total;
                            var currentValue = dataset.data[tooltipItem.index];
                            var percentage = parseFloat((currentValue / total * 100).toFixed(1));

                            var spentAmount = this.state.totalAwardAmountForAllCounty * (percentage / 100);

                            return numeral(spentAmount).format('($ 0.00 a)');
                        },
                        title: function (tooltipItem, data) {
                            return data.labels[tooltipItem[0].index];
                        }
                    }
                }
            },
            centerText: {
                display: true,
                text: parseInt(percentAmoutSpent) + "%"
            },
            plugins: [{
                beforeDraw: (chart, options) => {
                    //..
                    if (chart.config.centerText.display !== null &&
                        typeof chart.config.centerText.display !== 'undefined' &&
                        chart.config.centerText.display) {
                        this.drawTotals(chart);
                    }
                }
            }]
        };

        return config
    }

    drawTotals = (chart) => {

        var width = chart.chart.width,
            height = chart.chart.height,
            ctx = chart.chart.ctx;

        ctx.restore();
        var fontSize = (height / 94).toFixed(2);
        ctx.font = fontSize + "em sans-serif";
        ctx.textBaseline = "middle";

        var text = chart.config.centerText.text,
            textX = Math.round((width - ctx.measureText(text).width) / 2),
            textY = height / 2;

        ctx.fillText(text, textX, textY);
        ctx.save();
    }

    render() {
        return (

            <div className="pie-chart-container inline-grid">
                <div>
                    <span className="section-title form-margin-16">Total money spent by county</span>
                    <div className="height-10"></div>
                    <div className="layout horizontal form-margin-16 title-divider"></div>
                </div>
                <div className="pie-chart">
                    <NewChart config={this.calculateConfig()} />
                </div>
            </div>
        )
    }

}


export default connect(mapStateToProps, null)(AvailableGrantFundsDoughnutChart);
